import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const RouteGuard = () => {
  const token = sessionStorage.getItem("borrower_token");
  const expiry = token ? JSON.parse(atob(token.split(".")[1])).exp : null;
  return (
    <>
      <div>
        {expiry > Math.floor(new Date().getTime() / 1000) ? (
          <Outlet />
        ) : (
          <Navigate to="/home" />
        )}
      </div>
    </>
  );
};

export default RouteGuard;
